import React, { useEffect, useState } from 'react'
import { Link, withRouter } from 'react-router-dom'
import { Col, Menu, Row } from 'antd'
import SubMenu from 'antd/es/menu/SubMenu'
import { ReadOutlined } from '@ant-design/icons'
import styles from './Docs.module.scss'
import useWindowSizes from '../hooks/useWindowSizes'
import TermsDoc from './TermsDoc'
import RefundDoc from './RefundDoc'

function Docs({ current }) {
	const [isMobile, setIsMobile] = useState(false)
	const { windowWidth } = useWindowSizes()

	useEffect(() => {
		if (windowWidth <= 450) {
			setIsMobile(true)
		} else {
			setIsMobile(false)
		}
	}, [windowWidth])

	return (
		<Row gutter={25} className={styles.docsRowContainer}>
			<Col xs={isMobile ? 6 : 8} sm={5} md={5} lg={3} xl={3}>
				{isMobile ? (
					<Menu style={{ height: '100vh' }} selectedKeys={current}>
						<SubMenu
							className={styles.docsSubMenu}
							title={<ReadOutlined style={{ fontSize: '20px', lineHeight: '47px' }} />}
						>
							<Menu.ItemGroup key='g2' title='Terms'>
								<Menu.Item key='terms'>
									<Link to='/docs/terms'>Terms of use</Link>
								</Menu.Item>

								<Menu.Item key='refund'>
									<Link to='/docs/refund'>Refund Policy</Link>
								</Menu.Item>
							</Menu.ItemGroup>
						</SubMenu>
					</Menu>
				) : (
					<Menu style={{ height: '100vh' }} mode='inline' selectedKeys={current}>
						<Menu.ItemGroup key='g2' title='Terms'>
							<Menu.Item key='terms'>
								<Link to='/docs/terms'>Terms of use</Link>
							</Menu.Item>

							<Menu.Item key='refund'>
								<Link to='/docs/refund'>Refund policy</Link>
							</Menu.Item>
						</Menu.ItemGroup>
					</Menu>
				)}
			</Col>

			<Col xs={isMobile ? 18 : 16} sm={19} md={19} lg={21} xl={21} className={styles.docsContentContainer}>
				{current === 'terms' && <TermsDoc isMobile={isMobile} />}
				{current === 'refund' && <RefundDoc isMobile={isMobile} />}
			</Col>
		</Row>
	)
}

export default withRouter(Docs)
